import styled from 'styled-components';
import { ChipStyleMixin } from 'shared/styles';

export const EditWorkflowContainer = styled.div`
  display: flex;
  height: 100%;
  overflow: auto;
  div.wf-left-pane {
    flex: 1;
    overflow: auto;
    div.wf-btns {
      display: flex;
      align-items: center;
      padding: 12px 20px;
      background-color: rgb(255, 255, 255);
      box-shadow: rgba(18, 52, 77, 0.06) 0px -4px 4px;
      position: sticky;
      bottom: 0;
      z-index: 5;
    }
  }
  div.wf-left-header {
    padding: 24px 40px;
    background-color: rgb(255, 255, 255);
    margin-bottom: 24px;
  }
  div.wf-right-pane {
    width: 350px;
    background: rgb(255, 255, 255);
    border-left: 1px solid rgb(236, 236, 236);
    padding: 34px;
  }
  .wf-title {
    margin-bottom: 16px;
    color: var(--base-color);
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
    display: flex;
    gap: 24px;
  }
  .wf-description {
    margin-bottom: 16px;
    font-size: 12px;
    line-height: 22px;
    color: var(--color-smoke-700);
    text-align: left;
  }
  .wf-h-fields {
    display: flex;
    & > :not(:last-child) {
      margin-right: 16px;
    }
  }
  .wf-sb-label {
    margin-bottom: 12px;
    font-size: 12px;
    font-weight: 400;
  }
  .wf-sb-toggle {
    span {
      display: flex;
    }
  }
`;

export const WorkflowCard = styled.div`
  padding: 24px 40px;
  margin: 0px 20px 20px;
  border-radius: 6px;
  background-color: rgb(255, 255, 255);
  div.wf-row-condition {
    display: block;
  }
  div.wf-row {
    display: flex;
    gap: 24px;
    align-items: baseline;
    width: 100%;
    > div {
      width: 320px;
    }
  }

  .bp3-popover-content {
    position: relative;
  }
  .bp3-input-group {
    display: flex;
    align-items: end;
    padding-right: 8px;
    border: unset;
    font-size: 14px;
    line-height: 32px;
    border-radius: 5px;
    border: 1px solid #cfd7df;
    input {
      border: none;
    }
  }
`;

export const ConditionGroupContainer = styled.div`
  display: flex;
`;

export const Group = styled.div`
  padding: 24px;
  margin: 24px 0px;
  flex: 1;
  overflow: auto;
  border: 1px solid rgb(239, 239, 239);
  border-radius: 4px;
  .wf-action-group {
    display: flex;
    align-items: baseline;
  }
  & > :not(:last-child) {
    margin-bottom: 24px;
  }
  div.wf-c-delete {
    margin-right: 8px;
  }
  div.wf-cg-container {
    display: flex;
    align-items: baseline;
  }
`;

export const IntOperator = styled.div`
  font-size: 0.85rem;
  width: fit-content;
  background-color: rgb(235, 240, 252);
  padding: 4px 12px;
  text-transform: uppercase;
  border-radius: 4px;
  font-weight: 500;
  letter-spacing: 1px;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  div.t-w-h-row {
    flex: 1;
    display: flex;
    gap: 24px;
    align-items: baseline;
    margin-bottom: 24px;
  }
  div.t-w-h-flex {
    flex: 1;
  }
  .svg-wrapper {
    display: none;
  }
  #quill-wf-payload + .editor-action {
    background-color: white;
    padding: 12px 8px;
    bottom: 50px;
    border-radius: 4px;
    &.is-open .label-action {
      padding: 0;
    }
  }
`;

export const WorkflowListContainer = styled.div`
  div.wf-l-top-container {
    background-color: rgb(255, 255, 255);
    width: 100%;
    padding: 24px 10% 0px;
    z-index: 1;
    position: sticky;
    top: 0px;
  }
  div.wf-l-bottom-container {
    width: 80%;
    margin: 0px auto;
    padding: 12px 0;
  }
  div.wf-t-c-top-pane {
    display: flex;
    align-items: center;
  }
  div.wf-t-c-left-pane {
    flex: 1;
  }
  div.wf-t-c-right-pane {
  }
  div.wf-l-heading {
    margin-bottom: 16px;
    color: var(--base-color);
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
  }
  div.wf-l-description {
    margin-bottom: 16px;
    font-size: 12px;
    line-height: 22px;
    color: var(--color-smoke-700);
    text-align: left;
  }
  div.wf-l-auto-info {
    display: flex;
    padding: 12px 0;
    margin-bottom: 12px;
    span.wf-l-a-tp {
      font-size: 0.9rem;
      font-weight: 400;
      flex: 1;
      display: flex;
      align-items: center;
    }
  }
  div.wf-l-a-filter {
    display: flex;
    align-items: center;
    span.wf-f-s-count {
      margin-right: 8px;
    }
  }
  div.dragger {
    display: table-cell;
    vertical-align: inherit;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 12px;
    font-weight: 600;
    padding: 12px 0 12px 12px;
    text-align: left;
    width: 22px;
  }
`;

export const WorkflowListTable = styled.div`
  display: table;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0px 8px;
  box-sizing: border-box;
  text-indent: initial;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  div.wf-l {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
    position: relative;
    > div {
      display: table-row;
      vertical-align: inherit;
    }
  }
  div.wf-l-item-reorder {
    width: 22px;
  }
  div.wf-l-item-title {
    font-weight: 500;
    width: 450px;
    a {
      font-size: 15px;
      color: rgb(18, 52, 77);
    }
    a:hover {
      color: rgb(43, 92, 197);
      text-decoration: none;
    }
  }
  div.wf-l-item-actions {
    .created-at {
      font-weight: 400;
      font-size: 12px;
      line-height: 1.2;
      color: rgb(117, 117, 117);
    }
    .created-by {
      gap: 4px;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: rgb(18, 52, 77);
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 8px;
    }
    div.wf-l-i-a {
      ${ChipStyleMixin}
      border-radius: 4px;
      background-color: rgb(255, 255, 255);
      border: 1px solid rgb(207, 215, 223);
      font-size: var(--font-size-12);
      color: var(--base-color);
      display: inline-block;
      width: auto;
      font-weight: 500;
      word-break: break-all;
      white-space: nowrap;
      margin-right: 5px;
    }
  }
  div.wf-l-item-userinfo {
    width: 220px;
  }
  div.wf-l-item-options {
    text-align: right;
    font-weight: 500;
    padding-right: 36px;
    width: 60px;
  }
  div.wf-l-item-toggle {
    width: 65px;
    text-align: right;
  }
  .created-by {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: rgb(18, 52, 77);
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 8px;
  }
`;

export const WorkflowListHeader = styled.div`
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
  padding: 8px 24px;
  font-size: 12px;
  font-weight: 600;
  color: rgb(9, 30, 66);
  gap: 20px;

  > div {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
    border-radius: 5px;
  }
`;

export const WorkflowListCell = styled.div<{ padding: string }>`
  display: table-cell;
  vertical-align: inherit;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
  font-weight: 600;
  padding: ${({ padding }) => (padding ? padding : '12px')};
  text-align: left;
  &.header {
    padding: 5px 12px;
  }
`;
